module.exports = __webpack_public_path__ + "static/media/dashboard_banner.08ea3263.jpeg";